
/**
 * 判断元素是否出现在可视范围内
 */
function inView(el, options = {}) {
    // 取得元素在可视区的位置(相对浏览器视窗)左右上下
    const bcr = el.getBoundingClientRect();
    const mw = el.offsetWidth;
    const mh = el.offsetHeight;
    const w = window.innerWidth;
    const h = window.innerHeight;

    const boolX = (!((bcr.right - options.left) <= 0 && ((bcr.left + mw) - options.left) <= 0) && !((bcr.left + options.right) >= w && (bcr.right + options.right) >= (mw + w)));
    const boolY = (!((bcr.bottom - options.top) <= 0 && ((bcr.top + mh) - options.top) <= 0) && !((bcr.top + options.bottom) >= h && (bcr.bottom + options.bottom) >= (mh + h)));
    return el.width !== 0 && el.height !== 0 && boolX && boolY;
}

class LazyLoadImg {
    constructor(options = {}) {
        this.options = {
            el: document.querySelector('body'),
            // 设置一个检测时间间隔
            time: 300,
            // 页面内所有数据图片加载完成后，是否自己销毁程序， true默认销毁，false不销毁
            done: true,
            // 只要其中一个位置符合条件，都会触发加载机制
            position: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            before(el) {
                // 图片加载之前，执行的钩子函数
            },
            success(el) {
                // 图片加载成功，执行的钩子函数
            },
            error(el) {
                // 图片加载失败，执行的钩子函数
                if(el.tagName.toLowerCase() === 'img') {
                    el.src = require('../../image/dot.png');
                    // 拿到父节点:
                    var parent = self.parentElement;
                    // 删除自己:
                    parent && parent.removeChild(self);
                }
            }
        };
        options.position = Object.assign({}, this.options.position, options.position);
        options.diy = Object.assign({}, this.options.diy, options.diy);
        Object.assign(this.options, options);
        this.start();
    }
    start() {
        this._timer = true;
        this._start();
    }
    _start() {
        const options = this.options;
        // 清除定时器
        clearTimeout(this._timer);
        if(!this._timer) {
            return;
        }
        this._timer = setTimeout(() => {
            const list = Array.prototype.slice.apply(options.el.querySelectorAll('[data-src]'));
            if(!list.length && options.done) {
                return clearTimeout(this._timer);
            }
            list.forEach((el) => {
                if(!el.dataset.LazyLoadImgState && inView(el, options.position)) {
                    this.loadImg(el);
                }
            });
            this._start();
        }, options.time);
    }
    loadImg(el) {
        const options = this.options;
        if(options.loadImg) {
            options.loadImg(el);
            return;
        }
        el.dataset.LazyLoadImgState = 'start';
        options.before.call(this, el);
        const img = new Image();
        img.src = el.dataset.src;
        // 图片加载成功
        img.addEventListener('load', () => {
            if(el.tagName.toLowerCase() === 'img') {
                el.src = img.src;
            } else {
                el.style.backgroundImage = `url(${img.src})`;
            }
            delete el.dataset.src;
            delete el.dataset.LazyLoadImgState;
            return options.success.call(this, el);
        }, false);
        // 图片加载失败
        img.addEventListener('error', () => {
            delete el.dataset.src;
            delete el.dataset.LazyLoadImgState;
            el.parentElement.remove();
            options.error.call(this, el);
        }, false);
    }
    destroy() {
        delete this._timer;
    }
}

export default LazyLoadImg;



// WEBPACK FOOTER //
// ./src/common/component/lazy-load-img/index.js